import { useSyncExternalStore } from 'react';

const QUERY = '(min-width: 900px)';

const subscribe = (callback: () => void) => {
	const mql = window.matchMedia(QUERY);
	mql.addEventListener('change', callback);
	return () => mql.removeEventListener('change', callback);
};

const getSnapshot = () => window.matchMedia(QUERY).matches;

export const useIsDesktopLayout = () =>
	useSyncExternalStore(subscribe, getSnapshot);
